import { render, staticRenderFns } from "./RecordedShowList.vue?vue&type=template&id=19251b8f&"
import script from "./RecordedShowList.vue?vue&type=script&lang=js&"
export * from "./RecordedShowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports